"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _glamor = require("glamor");

var _components = require("components");

var _Section = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Section");

var _Section2 = _interopRequireDefault(_Section);

var _Hero = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Hero");

var _Hero2 = _interopRequireDefault(_Hero);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _cloudFront = require("../../utils/cloudFront");

var cloudFrontUtils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cf = function cf(path) {
  return __CLIENT__ && "https://d3uwib8iif8w1p.cloudfront.net/megascans/" + path || "";
};
var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return "https://cdn.quixel.com/quixel/thumbs/" + path;
};

var para = (0, _glamor.css)(_fonts.p3, {
  color: _css.colors.gray
});

var jobContainer = (0, _glamor.css)({
  display: "flex",
  justifyContent: "center"
});

var jobSubContainer = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-between",
  borderBottom: "2px solid #222",
  alignItems: "center",
  textAlign: "left",
  paddingTop: "1.625rem",
  paddingBottom: "1.625rem"
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  maxWidth: 960
}), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  maxWidth: 960
}), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  minWidth: 700
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  minWidth: 650
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  minWidth: 450
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  minWidth: 350
}), (0, _css.maxWidth)(_css.breakpoints.small)({
  minWidth: 271
}));

var containerSection = (0, _glamor.css)({
  flexBasis: "50%"
});

var containerSectionL = (0, _glamor.css)({
  flexBasis: "70%"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  flexBasis: "60%"
}));

var containerSectionR = (0, _glamor.css)({
  flexBasis: "30%"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  flexBasis: "40%"
}));

var headingRow = (0, _glamor.css)({
  marginTop: "3rem"
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  marginTop: "6rem"
}));

var label = (0, _glamor.css)(_fonts.subH2, {
  letterSpacing: "unset",
  textTransform: "uppercase"
});

var groupedPlugins = {
  blender: {
    title: "Blender",
    platforms: ["win", "mac", "linux"],
    help: "https://docs.google.com/document/d/1QGh6JbG7MQSaFUlg4M4fUuMvuIQSQhSLWH-v0nSjAhY/edit?usp=sharing",
    versions: [{
      version: "3.7",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/blender/win/3.7.zip"
    }, {
      version: "3.6",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/blender/win/3.6.zip"
    }, {
      version: "3.5",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/blender/win/3.5.zip"
    }]
  },
  cinema4d: {
    title: "Cinema 4D",
    platforms: ["win", "mac"],
    help: "https://docs.google.com/document/d/1dF3aa-v6MPBAZ2YISUCQgIJzoPbf5ss26II2mNuwLU8/edit?usp=sharing",
    versions: [{
      version: "2.2",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/cinema4d/win/2.2.zip"
    }, {
      version: "2.1",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/cinema4d/win/2.1.zip"
    }, {
      version: "2.0",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/cinema4d/win/2.0.zip"
    }]
  },
  clarisse: {
    title: "Clarisse",
    platforms: ["win", "mac", "linux"],
    help: "https://docs.google.com/document/d/1rI9XOGvuc3k5_bO6_ZVDCVVzHDppFjSXhEFjESo40cQ/edit?usp=sharing",
    versions: [{
      version: "1.4",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/clarisse/win/1.4.zip"
    }, {
      version: "1.1",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/clarisse/win/1.1.zip"
    }, {
      version: "1.0",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/clarisse/win/1.0.zip"
    }]
  },
  houdini: {
    title: "Houdini",
    platforms: ["win", "mac", "linux"],
    help: "https://docs.google.com/document/d/1fvgvrPEXvtF5btBU3eAwIAQt8KccGkXdkRRvmby7jZo/edit?usp=sharing",
    versions: [{
      version: "4.6",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/houdini/win/4.6.zip"
    }, {
      version: "4.5",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/houdini/win/4.5.zip"
    }, {
      version: "4.4.1",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/houdini/win/4.4.1.zip"
    }]
  },
  marmoset: {
    title: "Marmoset Toolbag",
    platforms: ["win", "mac"],
    help: "https://docs.google.com/document/d/1I4rk1AvAuDXLDoMaYKVyIsMvDrCqfaOaXQunWozTU3w/edit?usp=sharing",
    versions: [{
      version: "3.5",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/marmoset/win/3.5.zip"
    }, {
      version: "3.4",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/marmoset/win/3.4.zip"
    }, {
      version: "3.3",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/marmoset/win/3.3.zip"
    }]
  },
  max: {
    title: "3ds Max",
    platforms: ["win"],
    help: "https://docs.google.com/document/d/1zFqfVT-3hPjSq1HxcqY0P9BjnSDIwttVwftkurchi8c/edit?usp=sharing",
    versions: [{
      version: "5.5",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/max/win/5.5.zip"
    }, {
      version: "5.4",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/max/win/5.4.zip"
    }, {
      version: "5.3",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/max/win/5.3.zip"
    }]
  },
  maya: {
    title: "Maya",
    platforms: ["win", "mac", "linux"],
    help: "https://docs.google.com/document/d/1elvkBvVrCTAPiPEcvJqmakl73kuFr4PVwLXcw333y64/edit?usp=sharing",
    versions: [{
      version: "7.1",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/maya/win/7.1.zip"
    }, {
      version: "7.0",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/maya/win/7.0.zip"
    }, {
      version: "6.9",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/maya/win/6.9.zip"
    }]
  },
  unity: {
    title: "Unity",
    platforms: ["win", "mac"],
    help: "https://docs.google.com/document/d/1NUAh2vQ9UgK-c1J-yhVnqkTgqZxMVm77rRK-X1ukWw0/edit?usp=sharing",
    versions: [{
      version: "4.0",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/unity/win/4.0.zip"
    }, {
      version: "3.13",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/unity/win/3.13.zip"
    }]
  },
  unreal: {
    title: "UE4",
    platforms: ["win", "mac", "linux"],
    help: "https://docs.google.com/document/d/1SxFda2-66qjPtqVxXkmy9S7AlJachQpp96ddH0dMg6o/edit",
    versions: [{
      version: "7.6",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/unreal/win/7.6.zip"
    }, {
      version: "7.5",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/unreal/win/7.5.zip"
    }, {
      version: "7.4",
      url: "https://quixel-megascans-static.s3.us-west-2.amazonaws.com/bridge/plugins_12/unreal/win/7.4.zip"
    }]
  }
};

var PluginRow = function PluginRow(props) {
  return _react2.default.createElement(
    "div",
    { className: jobSubContainer },
    _react2.default.createElement(
      "div",
      { className: containerSectionL },
      _react2.default.createElement(_components.TextButtonLibrary, {
        className: (0, _glamor.css)({
          padding: 0,
          fontWeight: "400",
          fontSize: "18px",
          textTransform: "none"
        }),
        href: props.url,
        newWindow: true,
        label: "Plugin v" + props.version
      })
    )
  );
};

var PluginSection = function PluginSection(_ref) {
  var index = _ref.index,
      plugins = _ref.plugins;
  return _react2.default.createElement(
    "div",
    { className: (0, _glamor.css)(jobContainer) },
    _react2.default.createElement(
      "div",
      { className: containerSection },
      _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)(jobSubContainer, index !== 0 && headingRow) },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { className: label },
            "" + plugins.title
          ),
          _react2.default.createElement(
            "span",
            {
              className: (0, _glamor.css)(label, {
                fontWeight: 500,
                color: _css.colors.gray,
                padding: "0 12px"
              }) },
            " | "
          ),
          _react2.default.createElement(
            "span",
            {
              className: (0, _glamor.css)(label, {
                fontWeight: 500,
                color: _css.colors.gray,
                textTransform: "uppercase",
                paddingRight: 15
              }) },
            "" + plugins.platforms.join(" \xB7 ")
          ),
          _react2.default.createElement(
            "span",
            {
              className: (0, _glamor.css)({
                display: "inline-block",
                verticalAlign: "text-bottom"
              }) },
            _react2.default.createElement(
              "a",
              {
                className: (0, _glamor.css)(para, {
                  display: "inline-block",
                  lineHeight: "1.2",
                  transition: "all 0.2s",
                  textTransform: "none",
                  textDecoration: "none"
                }, {
                  fontSize: "0.9rem",
                  padding: "0px 6px",
                  fontWeight: 700,
                  cursor: "pointer",
                  borderRadius: "50%",
                  border: "2px solid " + _css.colors.gray,
                  color: _css.colors.gray,
                  ":hover": {
                    color: _css.colors.white,
                    border: "2px solid " + _css.colors.white
                  }
                }),
                href: plugins.help,
                target: "_blank",
                rel: "noreferrer" },
              "?"
            )
          )
        )
      ),
      plugins.versions.map(function (plugin) {
        return _react2.default.createElement(PluginRow, plugin);
      })
    )
  );
};

var Plugins = function (_React$Component) {
  (0, _inherits3.default)(Plugins, _React$Component);

  function Plugins() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Plugins);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Plugins.__proto__ || (0, _getPrototypeOf2.default)(Plugins)).call.apply(_ref2, [this].concat(args))), _this), _this.renderHeader = function () {
      return _react2.default.createElement(_Hero2.default, {
        bg: cloudFrontUtils.cf_qx_page("archviz", "bridge-hero.jpg"),
        superIconUrls: [cf("home/quixel_2080_logo.png")],
        primaryLabel: "",
        primaryTo: "",
        title: "ONE-CLICK INTEGRATIONS",
        subTitle: "Easily manage your 3D & 2D assets and send to any DCC, engine or renderer",
        secondaryLabel: "",
        secondaryTo: ""
      });
    }, _this.renderContent = function () {
      return _react2.default.createElement(_Section2.default, {
        innerClassName: (0, _glamor.css)({ marginBottom: "4.5rem" }),
        subHeading: "",
        title: "BRIDGE PLUGINS",
        headingBeforeBreak: "We hire creative, passionate people,",
        headingAfterBreak: "and give them the autonomy to do great work.",
        content: _this.renderPlugins()
      });
    }, _this.renderPlugins = function () {
      return (0, _keys2.default)(groupedPlugins).map(function (key, index) {
        return _react2.default.createElement(PluginSection, { index: index, plugins: groupedPlugins[key] });
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Plugins, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: " - Plugins",
          documentImage: cloudfrontThumbs("page-thumb-jobs.jpg"),
          documentDescription: "Easily manage your 3D & 2D assets and send to any DCC, engine or renderer." },
        _react2.default.createElement(
          "div",
          null,
          this.renderHeader(),
          this.renderContent()
        )
      );
    }
  }]);
  return Plugins;
}(_react2.default.Component);

exports.default = Plugins;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Plugins/Plugins.jsx
// module id = 2637
// module chunks = 0